/**
 * @generated SignedSource<<abd543b479f8a8a785093503cd9419e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerInfo_seller$data = {
  readonly agreementStart: string | null;
  readonly analytics: {
    readonly metrics: {
      readonly responseTime: {
        readonly value: number | null;
      } | null;
    } | null;
  } | null;
  readonly liveStorefrontProfile: {
    readonly establishmentYear: string | null;
  } | null;
  readonly monthsSinceStartDate: number | null;
  readonly sellerOrderQuantity: number | null;
  readonly tradeAssociations: ReadonlyArray<{
    readonly displayName: string | null;
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedDealerInfo_seller";
};
export type PdpSharedDealerInfo_seller$key = {
  readonly " $data"?: PdpSharedDealerInfo_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDealerInfo_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerInfo_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agreementStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sellerOrderQuantity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalytics",
      "kind": "LinkedField",
      "name": "analytics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCAnalyticsMetrics",
          "kind": "LinkedField",
          "name": "metrics",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MCMetricResponseTime",
              "kind": "LinkedField",
              "name": "responseTime",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "kind": "LinkedField",
      "name": "tradeAssociations",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "establishmentYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "aee88a42018bdbf50e9239c7a3d35605";

export default node;
